<app-header></app-header>
<!--=========== breadcumb Area ============-->
<div class="breadcumb-wrapper " data-bg-src="assets/img/bg/breadcumb-bg.jpg">
    <div class="container">
        <div class="breadcumb-content">
            <h1 class="breadcumb-title">Blog Details</h1>
            <ul class="breadcumb-menu">
                <li><a routerLink="/">Home</a></li>
                <li>{{ blog.title }}</li>
            </ul>
        </div>
    </div>
</div>
<!--============= Blog Area ======================-->
<section class="th-blog-wrapper blog-details space-top space-extra-bottom">
    <div class="container">
        <div class="row">
            <div class="col-xxl-8 col-lg-7">
                <div class="th-blog blog-single">
                    <div class="blog-img">
                        <img class="blog-lg-feature-img" [src]="blog.featured_image" (error)="onImageError($event)"
                            alt="{{ blog.title }}" />
                    </div>
                    <div class="blog-content">
                        <div class="blog-meta">
                            <a class="author" routerLink="/latest-news/{{ blog.slug }}">
                                <i class="fa-light fa-user"></i>by Team Xipetech</a>
                            <a routerLink="/latest-news/{{ blog.slug }}">
                                <i class="fa-regular fa-calendar"></i>{{ blog.published_at | date:'dd MMMM yyyy' }}</a>
                        </div>
                        <h2 class="blog-title" [innerHTML]="blog.title">{{ blog.title ?? '' }}</h2>
                        <p class="blog-text mb-30" [innerHTML]="blog.content">{{ blog.content ?? '' }}</p>
                        <div class="share-links clearfix ">
                            <div class="row justify-content-between">
                                <div class="col-md-auto">
                                    <span class="share-links-title">Tags:</span>
                                    <div class="tagcloud" *ngIf="terms && terms.length > 0">
                                        <a *ngFor="let term of terms" routerLink="/latest-news/{{ blog.slug }}">
                                            {{ term.name ?? '' }}
                                        </a>
                                    </div>
                                </div>
                                <div class="col-md-auto text-xl-end">
                                    <div class="share-links_wrapp">
                                        <span class="share-links-title">Share:</span>
                                        <div class="social-links">
                                            <a [href]="'https://www.facebook.com/sharer/sharer.php?u=' + postUrl"
                                                target="_blank">
                                                <i class="fab fa-facebook-f"></i>
                                            </a>
                                            <a [href]="'https://twitter.com/intent/tweet?url=' + postUrl + '&text=' + blog.title"
                                                target="_blank">
                                                <i class="fab fa-twitter"></i>
                                            </a>
                                            <a [href]="'https://www.linkedin.com/sharing/share-offsite/?url=' + postUrl"
                                                target="_blank">
                                                <i class="fab fa-linkedin-in"></i>
                                            </a>
                                        </div>
                                    </div>
                                </div><!-- Share Links Area end -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-xxl-4 col-lg-5">
                <app-blog-sidebar></app-blog-sidebar>
            </div>
        </div>
    </div>
</section>

<!--======== Footer Section ========-->
<app-footer></app-footer>